/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import './Spotlight3Images.scss';
import { AiOutlineEye } from 'react-icons/ai';
import { ethers } from 'ethers';
import {
  useContract,
  useSigner,
  useContractRead,
} from 'wagmi';

import JSConfetti from 'js-confetti';
import { toast } from 'react-toastify';
import useSpotlight3Store from '../../store/useSpotlight3Store';
import 'react-toastify/dist/ReactToastify.css';
import abi from './Layerr1155.json';

function Spotlight3Images() {
  const jsConfetti = new JSConfetti();
  const [eligible, setEligible] = useState(true);
  const [setFeaturedImage, setFeaturedImageDescription] = useSpotlight3Store((state) => [state.setFeaturedImage, state.setFeaturedImageDescription]);
  const [qty0, setQty0] = useState(1);
  const [qty1, setQty1] = useState(1);
  const { data: signer } = useSigner();

  const contract = useContract({
    address: '0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A',
    abi: abi.abi,
    signerOrProvider: signer,
  });

  const readQuantity0 = useContractRead({
    address: '0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A',
    abi: abi.abi,
    functionName: 'tokenEditionMints',
    args: [0],
  });

  const readQuantity1 = useContractRead({
    address: '0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A',
    abi: abi.abi,
    functionName: 'tokenEditionMints',
    args: [1],
  });

  const tokens = [
    {
      id: 2,
      imgSrc: 'https://live.staticflickr.com/65535/52668031949_8042f5eb01_k.jpg',
      description: 'It doesn’t matter where you think this road will take you, all that matters is living in the moment. You can never know where the road ends but at least we’ll be together.',
      label: 'Together',
      subLabel1: '0.00616 ETH',
      subLabel2: readQuantity0.data?.toNumber(),
    },
    {
      id: 1,
      imgSrc: 'https://live.staticflickr.com/65535/52684964307_c49ade443f_h.jpg',
      description: 'Within every Dystopia there’s a little Utopia. It just depends where you are. Hoping and fighting against things that are bigger than ourselves.  ',
      label: 'Dystopia',
      subLabel1: '0.00616 ETH',
      subLabel2: readQuantity1.data?.toNumber(),
    },
  ];
  const handleMint = async () => {
    try {
      let price;
      if (qty0 === qty1) {
        price = qty0 * 0.006162 * 2;
        const bigNumberPrice = ethers.utils.parseEther(price.toString());
        await contract.mintAndClaim(2, qty0, { value: bigNumberPrice });
      } else if (qty0 !== qty1 && qty0 > 0 && qty1 > 0) {
        price = qty0 * 0.00616 + qty1 * 0.00616;
        const bigNumberPrice = ethers.utils.parseEther(price.toString());
        await contract.batchMint([0, 1], [qty0, qty1], { value: bigNumberPrice });
      } else if (qty0 > 0 && qty1 === '') {
        price = qty0 * 0.00616;
        const bigNumberPrice = ethers.utils.parseEther(price.toString());
        await contract.mint(0, qty0, { value: bigNumberPrice });
      } else if (qty1 > 0 && qty0 === '') {
        price = qty1 * 0.00616;
        const bigNumberPrice = ethers.utils.parseEther(price.toString());
        await contract.mint(1, qty1, { value: bigNumberPrice });
      }
      jsConfetti.addConfetti({ emojis: ['🎉', '🎈', '✨', '💫', '🎨'], confettiNumber: 100 });
      toast.success('Success!', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => { jsConfetti.clearCanvas(); }, 3000);
    } catch (error) {
      console.log(error.message);
      const inputString = error.message;
      const messageStartIndex = inputString.indexOf('message') + 10;
      const messageEndIndex = inputString.indexOf('",', messageStartIndex);
      const message = inputString.substring(messageStartIndex, messageEndIndex);

      toast.error(message, {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    // if the value is an empty string, set the qty to an empty string
    if (value === '') {
      if (index === 0) {
        setQty0('');
        setEligible(false);
      } else {
        setQty1('');
        setEligible(false);
      }
      // if the value is not a number, don't update the qty
    } else if (parseInt(value, 10)) {
      const parsedValue = parseInt(value, 10);
      if (!Number(parsedValue).isNAN) {
        if (index === 0) {
          setQty0(parsedValue);
          setEligible(false);
        } else {
          setQty1(parsedValue);
          setEligible(false);
        }
      }
      // make sure there are no errors if someone enters a NAN value, and that the input is cleared
    } else {
      value.replace('');
      setEligible(false);
    }
  };

  useEffect(() => {
    if (qty0 === qty1 && (qty0 !== '' || qty1 !== '')) {
      setEligible(true);
    } else {
      setEligible(false);
    }
  }, [qty0, qty1]);

  return (
    <section className="sptlght3-images">
      <div className="sptlght3-images__container">
        {tokens.map((token, index) => (
          <div key={token.id} style={{ height: '100%' }}>
            <div onClick={() => { setFeaturedImage(token.imgSrc); setFeaturedImageDescription(token.description); }} className="sptlght3-images__image-container">
              <AiOutlineEye className="sptlght3-images__eye" />
              <p className="sptlght3-images__image-description">{token.description}</p>
              <img className="sptlght3-images__image" src={token.imgSrc} alt="equilibrium" />
            </div>
            <div className="sptlght3-images__details-container">
              <div>
                <p className="sptlght3__label"><b>{token.label}</b></p>
                <p className="sptlght3__sub-label">{token.subLabel1}</p>
                <p className="sptlght3__sub-label">{token.subLabel2} Minted</p>
              </div>
              <div>
                <input onChange={(e) => { handleInputChange(e, index); }} value={index === 0 ? qty0 : qty1} placeholder="qty" className="sptlght3-images__input" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="sptlght3-images__eligible">
        <button data="Mint has ended" className="sptlght3-images__add" type="button" />
        <a style={{ textDecoration: 'underline', color: 'white' }} href="https://opensea.io/collection/we-are-connected-tylersjourney">View on OpenSea</a>
        {/* <div>
          {eligible && <p className="sptlght3-images__eligible-text">You will receive {qty0} extra FREE NFT{qty0 === 1 ? null : 'S'}, titled <b>Equilibrium</b>!</p>}
          {!eligible && <p className="sptlght3-images__eligible-text sptlght3-images__eligible-text--error">Not eligible for Free NFT &quot;Equilibrium&quot; </p>}
          <p>{`Total NFTs Received: ${eligible ? qty0 * 3 : qty0 + qty1}`}</p>
        </div> */}
      </div>
    </section>
  );
}

export default Spotlight3Images;
